export enum RolesIds {
  Administrator = 1,
  Storer = 2,
  Guest = 3,
  AreaManager = 4,
}

export const RolesOptions = [
  { id: RolesIds.Administrator, name: 'Administrador' },
  { id: RolesIds.Storer, name: 'Almacenista' },
  { id: RolesIds.Guest, name: 'Invitado' },
  { id: RolesIds.AreaManager, name: 'Jefe de Area' },
];
